module.exports = __webpack_public_path__ + "static/media/7.Miter saw.842cc877.jpg";